import { useState, useCallback, useRef, useEffect, useContext } from "react"
import { Badge } from "primereact/badge"
import TasksDialog from "./TasksDialog"
import { Toast } from "primereact/toast"
import NotificationsToastContent from "../notifications/notificationsToastContent"
import { useLazyQuery } from "@apollo/client"
import { gql } from "@apollo/client"
import { UserContext } from "../../context/userContext"
import { taskApiGetPendingTasksCount } from "./TasksApi"
import { LogError } from "../../helpers/logger"

const Tasks = () => {
  const [errorState] = useState(null) // Used, but never set, requires further investigation
  const toast = useRef(null)
  const isReconnecting = useRef(false)
  const [organizations, setOrganizations] = useState(null)
  const userCtx = useContext(UserContext)
  const pid = userCtx.participant_id

  const GET_PARTICIPANT_ORGNIZATIONS = gql`
    query Organizations($pid: ID!) {
      organizations: organizationsByPid(participant_id: $pid) {
        organization_id
        organization_name
        organization_alias
      }
    }
  `

  const [getOrganizations] = useLazyQuery(GET_PARTICIPANT_ORGNIZATIONS, {
    fetchPolicy: "cache-and-network",
    variables: {
      pid,
    },
  })

  useEffect(() => {
    try {
      getOrganizations({
        variables: {
          pid,
        },
      })
        .then((organizationList) => {
          setOrganizations(organizationList?.data?.organizations)
        })
        .catch((error) => {
          console.log("Unable to retrieve organization list", error)
          setOrganizations(null)
        })
    } catch (error) {
      console.log("Unable to retrieve organization list", error)
      setOrganizations(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  async function getPendingTasksCount() {
    try {
      const pendingCount = await taskApiGetPendingTasksCount(
        userCtx.tokens.getTaskToken(),
        {
          groupId: "All",
          userId: userCtx.participant_id,
        },
      )

      if (pendingCount) {
        userCtx.setPendingTasksCount(pendingCount)
      }
    } catch (error) {
      LogError(`Unable to get Pending Tasks Count`, error)
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Unable to get Pending Tasks Count.",
      })
    }
  }

  useEffect(() => {
    getPendingTasksCount()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const showError = useCallback(
    (message) => {
      const id = Date.now()
      if (toast.current) {
        toast.current.show({
          severity: "error",
          detail: id,
          closable: false,
          sticky: isReconnecting.current,
          content: (
            <NotificationsToastContent
              toast={toast}
              systemNotification
              isError
              toastId={id}
              description={message || errorState}
              isInfo={true}
            />
          ),
        })
      }
    },
    [errorState],
  )

  const handleButtonClick = () => {
    if (errorState) {
      showError()
    } else {
      userCtx.setTasksDialogVisible(true)
    }
  }

  return (
    <>
      <Toast ref={toast} position="top-right" />
      <TasksDialog
        visible={userCtx.tasksDialogVisible}
        onHide={() => userCtx.setTasksDialogVisible(false)}
        organizations={organizations}
      />
      <li
        className="top-icon"
        onClick={() => {
          handleButtonClick()
        }}
      >
        <i
          className="pi pi-check-circle p-overlay-badge"
          style={{ fontSize: "24px" }}
        >
          {userCtx.pendingTasksCount > 0 && (
            <Badge
              value={
                window.innerWidth > 1024 ? userCtx.pendingTasksCount : null
              }
            />
          )}
        </i>
        <label className="top-menu-label">Tasks</label>
      </li>
    </>
  )
}
export default Tasks
